import { ChevronRightIcon } from "@chakra-ui/icons";
import { Flex } from "@chakra-ui/react";
import { Row, RowData } from "@tanstack/react-table";
import TooltipIconButton from "components/Shared/TooltipIconButton";
import { ReactNode } from "react";
import { formatInteger } from "utils/formatting";

type Props<D extends RowData> = {
  children?: ReactNode;
  row: Row<D>;
};

export default function ExpandableCellWrapper<D extends RowData>({
  children,
  row,
}: Props<D>) {
  return (
    <Flex className="grouped-cell-wrapper" alignItems="center" gap={2}>
      <TooltipIconButton
        label={`${row.getIsExpanded() ? "Collapse" : "Expand"} ${formatInteger(
          row.subRows.length,
        )} row${row.subRows.length !== 1 ? "s" : ""}`}
        icon={<ChevronRightIcon />}
        onClick={row.getToggleExpandedHandler()}
        isDisabled={!row.getCanExpand()}
        borderRadius="md"
        p=".15em"
        sx={{
          "> svg": { transition: "transform 0.2s ease" },
          "tr[data-expanded] > td & > svg": {
            transform: "rotate(90deg)",
          },
        }}
      />

      {children}
    </Flex>
  );
}
